import { render, staticRenderFns } from "./review.vue?vue&type=template&id=7cf7f61d&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=7cf7f61d&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf7f61d')) {
      api.createRecord('7cf7f61d', component.options)
    } else {
      api.reload('7cf7f61d', component.options)
    }
    module.hot.accept("./review.vue?vue&type=template&id=7cf7f61d&", function () {
      api.rerender('7cf7f61d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/internalAudit/components/review.vue"
export default component.exports